import ProductCardRenderer from "../common/product-card-renderer";
const productCardRenderer = ProductCardRenderer();

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

const initializePageFavorite = () => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  const emptyElement = document.querySelector(".favorite-empty");
  const gridElement = document.querySelector(".media-grid-favorite");

  window.SwymCallbacks.push(() => {
    _swat.fetchWrtEventTypeET((items) => {
      const ids = items.map((item) => `gid://shopify/Product/${item.empi}`);
      if (ids.length <= 0) {
        gridElement.style.display = "none";
        emptyElement.style.display = "block";
        return;
      }
      window.ShopifyClient.fetchProducts(ids).then((products) => {
        if (products.length <= 0) {
          gridElement.style.display = "none";
          emptyElement.style.display = "block";
          return;
        }
        products.forEach((product) => {
          wishlist.addShopifyProductToViewProducts(product);
        });
        const items = products.map((product) => {
          const item = productCardRenderer.renderShopifyProduct(product);
          return `<div class="fs-media-grid-item">${item}</div>`;
        });
        if (0 < products.length % 4) {
          for (let i = 0; i < 4 - (products.length % 4); i++) {
            items.push(`<div class="fs-media-grid-item"></div>`);
          }
        }
        const itemsElement = gridElement.querySelector(".fs-media-grid-items");
        itemsElement.innerHTML = items.join("");

        addWishlistButtonListener(itemsElement);
        wishlist.updateButtons();

        gridElement.style.display = "block";
      });
    });
  });
};

const wishlistButtonListener = (e) => {
  const button = e.target;
  const cardEl = document.querySelector(`.fs-product-card[data-product-id="${button.dataset.productId}"]`);
  cardEl.parentElement.parentElement.insertAdjacentHTML("beforeend", '<div class="fs-media-grid-item"></div>');
  cardEl.parentElement.remove();
  wishlist.toggleWishlist(parseInt(button.dataset.productId));
};

const addWishlistButtonListener = (container) => {
  container.querySelectorAll(".fs-wishlist-button").forEach((button) => {
    button.removeEventListener("click", wishlistButtonListener);
    button.addEventListener("click", wishlistButtonListener);
  });
};

const pageFavoriteMain = () => {
  if (!location.pathname.startsWith("/pages/favorite")) {
    return;
  }
  initializePageFavorite();
};

addEventListener("DOMContentLoaded", () => {
  pageFavoriteMain();
});
